import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // For screens <= 1024px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // For screens <= 768px
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const testimonials = [
    {
      message:
        "Pink Help connected me with a wellness coach in Lahore who understood hormonal weight gain. I’ve lost 12 kg, but more importantly, I found a support system.",
      name: "Ayesha F.",
      role: "⚕️ Health – Weight Loss Support | Lahore, Pakistan",
    },
    {
      message:
        "I escaped an abusive relationship in São Paulo. Pink Help didn’t just list resources — they helped me find a lawyer who saved my life.",
      name: "Luciana R.",
      role: "⚖️ Legal – Domestic Violence Protection | São Paulo, Brazil",
    },
    {
      message:
        "As a mother of two in Nairobi, I thought I’d missed the boat on learning. Pink Help led me to a digital marketing certification that changed everything.",
      name: "Grace N.",
      role: "🎓 Education – Professional Certifications | Nairobi, Kenya",
    },
    {
      message:
        "After a decade away from the workforce in Toronto, I felt invisible. Pink Help matched me with a women-focused recruiter and I landed a part-time tech role.",
      name: "Melissa J.",
      role: "💼 Jobs – Return-to-Work Support | Toronto, Canada",
    },
    {
      message:
        "I started a home bakery during the lockdown in Manila. Pink Help gave me free branding resources and connected me to a grant program for women.",
      name: "Ana L.",
      role: "📊 Business – Home-Based Business Ideas | Manila, Philippines",
    },
    {
      message:
        "I used to live paycheck to paycheck in London. Pink Help’s financial guide for women opened my eyes — and my savings account.",
      name: "Kiran D.",
      role: "💰 Finance – Budgeting & Saving | London, UK",
    },
    {
      message:
        "I was homeless for 2 weeks in Houston with my son. Pink Help found me a women’s shelter before sunset. I’ll never forget that night.",
      name: "Nicole B.",
      role: "🏠 Housing – Emergency Shelters | Houston, USA",
    },
    {
      message:
        "In Amman, resources for single moms are limited. Pink Help gave me a place to vent, connect, and even find a parenting coach who gets it.",
      name: "Rania M.",
      role: "👪 Family – Single Parenting Support | Amman, Jordan",
    },
    {
      message:
        "As a hijabi entrepreneur in Jakarta, it was hard to find support in fashion. Pink Help introduced me to mentors in Dubai and I now run my own line.",
      name: "Dina A.",
      role: "👗 Fashion – Modest Fashion Styling | Jakarta, Indonesia",
    },
    {
      message:
        "After moving to Berlin, I had no one. Pink Help’s global women’s forum became my lifeline. I found friends and even a local therapist through them.",
      name: "Marta K.",
      role: "🌐 Community – Mental Health Peer Support | Berlin, Germany",
    },
  ];
  
  
  return (
    <>
      <div className="container-fluid p-0 m-0 overflow-hidden">
        <div className="row g-0">
          <h2 className="text-center mt-12 text-accent-blue font-aeonik text-3xl font-bold mb-10">
            What Clients Say
          </h2>
          <div className="col-12">
            <section className="bg-main-light py-12 px-6">
              <Slider {...settings}>
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="col-lg-4 col-md-4 col-12 p-4">
                    <div className="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-shadow duration-300">
                      <p className="text-text-color font-barlow text-lg">
                        "{testimonial.message}"
                      </p>
                      <h4 className="mt-4 text-main-green font-bold text-lg">
                        {testimonial.name}
                      </h4>
                      <p className="text-sm text-accent-blue">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                ))}
              </Slider>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestimonialSlider;
